<template>
    <page :delegated-loading="true"
          :fill-height="!addSort && $lodash.isEmpty(assessments) && !$wait.waiting(keys.riskAssessments.list)"
          :creation-action="createAssessment"
          :resource="keys.riskAssessments.key">
        <template #title="">
            <m-dialog-risk-assessment-create>
                {{$t('pages.dashboard.service.risk-assessment.index.title')}}
            </m-dialog-risk-assessment-create>
        </template>
        <template v-if="$wait.waiting(keys.riskAssessments.list) || assessments.length"
                  :loading="$wait.waiting(keys.riskAssessments.list)" #content="">
            <m-list-assessments :items="assessments"
                                :filter-items="filterItems"
                                :sort-items="sortItems"
                                v-bind.sync="query"
                                :addFilter="showFilter"
                                :addSort="true" />
        </template>
        <template v-else #content="">
            <m-list-assessments :filter-items="filterItems"
                              v-bind.sync="query"
                              :addFilter="showFilter"
                              :addSort="false" />
            <m-block-empty-page-content :line1-text="emptyMsg"
                                        :creation-action="createAssessment" />
        </template>
    </page>
</template>

<script>
    import basePage from "@mixins/components/pages/base";
    import {PAGINATION} from '@constants/common';
    import MListAssessments from "@modules/lists/concrete/m-list-assessments";
    import {mapActions, mapGetters} from 'vuex'
    import MDialogRiskAssessmentCreate from "@modules/dialogs/concrete/risk-assessment/m-dialog-risk-assessment-create";
    import MBlockEmptyPageContent from "../../../../modules/blocks/page/m-block-empty-page-content";

    let name = 'dashboard-service-risk-assessment-index';
    export default {
        name: name,
        components: {MBlockEmptyPageContent, MDialogRiskAssessmentCreate, MListAssessments},
        mixins: [basePage],
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.service.risk-assessment.index.meta.title')
            }
        },
        props: {
            name: {
                type: String,
                default: name
            },
            addFilter: {  // used to resize the Sort-Select when Filter appears
                type: Boolean,
                default: false
            },
            addSort: {  // used to resize the Filter-Select and to hide the Sort-Select for an empty list when Filter is active
                type: Boolean,
                default: true
            }
        },
        async created() {
            this.query.sort = this.sortItems.find((item) => item.default);
            this.query.filter = this.filterItems.find((item) => item.default);
        },
        data: () => ({
            query: {
                sort: null,
                filter: null,
                pagination: {
                    currentPage: 1,
                    itemsPerPage: PAGINATION.CHUNK,
                    totalItems: 0
                }
            },
            totalRA: 0
        }),
        computed: {
            ...mapGetters({
                getAssessments: 'riskAssessments/list'
            }),
            showFilter() {
                return (this.totalRA !== 0)
            },
            emptyMsg() {
                return (this.totalRA === 0 ? this.$t("empty.assessments") : this.$t("empty.assessments-filtered") )
            },
            assessments() {
                let result = this.getAssessments(this.query.sort);
                this.updateTotalRA();
                return result;
            },
            sortItems() {
                return [
                    {
                        text: this.$t('modules.sorts.m-sort-assessment.alpha.asc'),
                        field: 'name',
                        parentField:'metadata',
                        order: 'asc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-assessment.alpha.desc'),
                        field: 'name',
                        parentField:'metadata',
                        order: 'desc'
                    }, {
                        text: this.$t('modules.sorts.m-sort-assessment.updated.asc'),
                        field: 'updatedAt',
                        order: 'asc'
                    }, {
                        default: true,
                        text: this.$t('modules.sorts.m-sort-assessment.updated.desc'),
                        field: 'updatedAt',
                        order: 'desc'
                    }
                ]
            },
            filterItems() {
                return [
                    {
                        default: true,
                        text: this.$t('modules.filters.m-filter-assessment.all'),
                        field: 'all',
                        arg: 'true'
                    }, {
                        text: this.$t(`modules.filters.m-filter-assessment.completed`),
                        field: 'status',
                        arg: 'completed'
                    }, {
                        text: this.$t(`modules.filters.m-filter-assessment.in_progress`),
                        field: 'status',
                        arg: 'in_progress'
                    }, {
                        text: this.$t(`modules.filters.m-filter-assessment.action_required`),
                        field: 'actionRequiredSet',
                        arg: 'true'
                    }, {
                        text: this.$t(`modules.filters.m-filter-assessment.action_required_critical`),
                        field: 'actionRequired',
                        arg: 'critical'
                    }, {
                        text: this.$t(`modules.filters.m-filter-assessment.action_required_necessary`),
                        field: 'actionRequired',
                        arg: 'necessary'
                    }
                ]
            }
        },
        watch: {
            'query.sort': function () {
                this.requestAssessments();
            },
            'query.filter': function () {
                this.requestAssessments();
            },
            'query.pagination': function (prev, next) {
                if (prev.currentPage !== next.currentPage) {
                    this.requestAssessments();
                }
            },
            '': function () {

            }
        },
        methods: {
            ...mapActions({
                loadAssessments: 'riskAssessments/list',
                openModal: 'dialogs/open'
            }),
            updateTotalRA() {
                if (this.query.filter.field === "all") {
                    this.totalRA = this.query.pagination.totalItems;
                }
            },
            async requestAssessments() {
                this.query.pagination = await this.loadAssessments({
                    sort: this.query.sort,
                    filter: this.query.filter,
                    pagination: this.query.pagination
                });
                this.updateTotalRA();
            },
            async createAssessment(){
               const raId = await this.openModal('riskAssessmentCreate');
               if(raId){
                   this.redirect(this.nav.dashboard.service.risk_assessment.view.name, {id:raId})
               }
            }
        }
    }
</script>

<style scoped>

</style>
